import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { useRef, useState } from "react";
import SelectionDropdown from "src/modules/ui-elements/SelectionDropdown";
import Styles from "./SelectGenerationModel.module.css";
import { Icon, ICONS } from "../ui-elements/Icon";
import { MuiButtonStyle } from "@/theme/buttonStyle";
import {
  LORELIST,
  MODELLIST,
  REFINERSLIST,
  TYPELIST,
} from "../batchEditor/BulkUploadEditor/constant";
import RangeSlider from '../ui-elements/RangeSlider';
import Loader from "@/modules/ui-elements/Loader";
import { BULK_AI_TYPE } from "@/utils/toolsConstants";
import { useSelector } from "react-redux";

const LoraSelection = ({ addLoraHandler, selectedLora, scrollDown, selectedType }) => {
  const [weightValue, setWeightValue] = useState(0.5);

  const addItemHandler = (value) => {
    addLoraHandler({ model_name: value, weight: +weightValue });
    setWeightValue(0.5);
  };

  return (
    <div style={Style2.container2}>
      <SelectionDropdown
        dropdownTitle={"Lora List"}
        list={LORELIST?.filter(
          (item) => !selectedLora?.find((e) => e?.model_name === item)
        )}
        placeholder={"Select lora"}
        onSelection={addItemHandler}
        resetOnSelection={true}
        onClick={scrollDown}
        disabled={selectedType === "IMAGEN"}
      />
      <div className={selectedType === "IMAGEN" ? Styles.sliderContainerDisabled : Styles.sliderContainer} style={{ width: "150px" }}>
        <RangeSlider setValue={setWeightValue} title={"weight"} defaultValue={weightValue} />
      </div>
    </div>
  );
};

const loraValues = JSON.parse(process.env.NEXT_PUBLIC_DEFAULT_LORA_VALUE) || [{model_name: "SDXL_FILM_PHOTOGRAPHY_STYLE_V1.safetensors", weight: 0.25}, {model_name: "sd_xl_offset_example-lora_1.0.safetensors", weight: 0.1}];
const modelsValue = process.env.NEXT_PUBLIC_DEFAULT_MODELS_VALUE || "juggernautXL_juggXIByRundiffusion.safetensors";
const typelist = "STABLE_DIFFUSION";
const refinersValue = process.env.NEXT_PUBLIC_DEFAULT_REFINERS_VALUE || "realisticVisionV60B1_v51VAE.safetensors";
const refinersWeight = process.env.NEXT_PUBLIC_DEFAULT_REFINERS_WEIGHT || 0.5;

export default function SelectGenerationModel(props) {
  const { open, onClose, saveProject, applying=false } = props;
  const { bulkUplodAIType } = useSelector(state => state.fileUpload);
  const scrollContainerRef = useRef(null);
  const [selectedModel, setSelectedModel] = useState(modelsValue);
  const [selectedType, setSelectedType] = useState(typelist);
  const [selectedRefiners, setSelectedRefiners] = useState(refinersValue);
  const [selectedLora, setSelectedLora] = useState(loraValues);
  const [refineValue, setRefineValue] = useState(refinersWeight);
  const [loading, setLoading] = useState(false);

  const filteredTypeList = TYPELIST.filter(type => {
    if (bulkUplodAIType === BULK_AI_TYPE.BULK_UPLOAD_FACE_SWAP || 
        bulkUplodAIType === BULK_AI_TYPE.BULK_UPLOAD_MODEL_GEN) {
      return type !== "IMAGEN";
    }
    return true;
  });

  const closeDialog = () => {
    onClose();
  };

  const addLoraHandler = (value) => {
    setSelectedLora((prev) => [...prev, value]);
  };

  const removeLoraHandler = (value) => {
    setSelectedLora((prev) =>
      prev?.filter((item) => item?.model_name !== value?.model_name)
    );
  };

  const loraWeightHandler = (e, selected) => {
    e.preventDefault();
    setSelectedLora((prev) =>
      prev?.map((item) => {
        if (item?.model_name === selected?.model_name)
          return { ...item, weight: e.target.value };
        else item;
      })
    );
  };

  const scrollDown = () => {
    setTimeout(()=>{
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTop += 200;
      }
    },500);
  };

  const continueHandler = async () => {
    setLoading(true);
    const payload = {
      modelSelection: {
        baseModel: selectedModel,
        refinerModel: selectedRefiners,
        refinerSwitch: +refineValue,
        loraList: selectedLora,
        type: selectedType,
      },
    };
    saveProject(payload);
    await new Promise((res) => setTimeout(res, 5000));
    setLoading(false);
  };

  const disabledboxStyle = (selectedType, flag=true) => ({
    background: flag ? "#b5b5b1" : "",
    cursor: selectedType === "IMAGEN" ? "not-allowed" : "pointer",
    opacity: selectedType === "IMAGEN" ? 0.5 : 1,
    color: selectedType === "IMAGEN" ? "#666" : "rbg(102, 102, 102)",
  });

  return (
    <Dialog
      PaperProps={{
        sx: Style2.dialog,
      }}
      onClose={closeDialog}
      maxWidth="xl"
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      {applying && <div className={Styles.loader}>
        <div><Loader width={24} height={24}/></div>
        <p>Please Wait...</p>
      </div>}
      <DialogContent dividers >
        <div ref={scrollContainerRef} className={Styles.container}>
          <Icon
            src={ICONS.crossIcon}
            width={25}
            height={25}
            style={Style2.close}
            onClick={closeDialog}
          />
          <div style={Style2.modelContainer}>
            <SelectionDropdown
              dropdownTitle={"Type"}
              list={filteredTypeList}
              placeholder={selectedType || "Select Type"}
              onSelection={setSelectedType}
            />
          </div>
          <div style={Style2.modelContainer}>
            <SelectionDropdown
              dropdownTitle={"List of model"}
              list={MODELLIST}
              placeholder={selectedModel || "Select Model"}
              onSelection={setSelectedModel}
              disabled={selectedType === "IMAGEN"}
            />
          </div>
          <div style={Style2.modelContainer}>
            <SelectionDropdown
              dropdownTitle={"List of refiners"}
              list={REFINERSLIST}
              placeholder={selectedRefiners || "Select Refiners"}
              onSelection={setSelectedRefiners}
              disabled={selectedType === "IMAGEN"}
            />
            <div className={selectedType === "IMAGEN" ? Styles.sliderContainerDisabled : Styles.sliderContainer}>
              <RangeSlider setValue={setRefineValue} title={"Switch"} defaultValue={refineValue} />
            </div>
          </div>
            <div style={Style2.loraContainer}>
              <div>
                {selectedLora?.map((item) => (
                  <div style={Style2.loraBox}>
                    <p style={{
                      ...Style2.loraTitle,
                      ...disabledboxStyle(selectedType, false),
                    }}>
                      {item?.model_name}
                    </p>
                    <input
                      type={"text"}
                      value={+item?.weight}
                      style={{
                        ...Style2.loraInput,
                        ...disabledboxStyle(selectedType),
                      }}
                      onChange={(e) => loraWeightHandler(e, item)}
                      readOnly
                    />
                    <Icon
                      src={ICONS.crossIcon}
                      width={15}
                      height={15}
                      onClick={selectedType === "IMAGEN" ? undefined : () => removeLoraHandler(item)}
                      style={{
                        ...Style2.crossIcon,
                        ...disabledboxStyle(selectedType),
                      }}
                    />
                  </div>
                ))}
                <LoraSelection
                  selectedLora={selectedLora}
                  addLoraHandler={addLoraHandler}
                  scrollDown={scrollDown}
                  selectedType={selectedType}
                />
            </div>
          </div>
        </div>
        <Button
          sx={Style2.button}
          onClick={continueHandler}
          disabled={
            selectedType === "IMAGEN" ? 
              loading : 
              (!selectedModel || !selectedRefiners || !selectedType || loading)
          }
        >
           {loading ? <Loader width={16} height={16} /> : 'Continue'}
        </Button>
      </DialogContent>
    </Dialog>
  );
}

const Style2 = {
  dialog: {
    backgroundColor: "white",
    margin: 0,
    width: "600px",
    padding: "24px",
  },
  close: {
    position: "absolute",
    right: "15px",
    top: "15px",
    cursor: "pointer",
  },
  modelContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    border: "1px solid #b5b5b1",
    padding: "10px",
    alignItems: "center",
  },
  loraContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    border: "1px solid #b5b5b1",
    padding: "10px",
  },
  loraBox: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #000000",
    paddingBottom: "10px",
    background: "#eee",
    padding: "10px",
  },
  loraTitle: {
    maxWidth: "200px",
    height:"26px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minWidth: "200px",
    lineBreak: "anywhere",
  },
  loraInput: {
    textAlign: "center",
    height: "20px",
  },
  crossIcon: {
    cursor: "pointer",
    background: "#b5b5b1",
    padding: "4px",
    borderRadius: "50%",
    maxHeight:"22px",
  },
  button: {
    ...MuiButtonStyle.darkToDarker,
    width: "100%",
  },
  container2: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
};
